<template>
    <ASMHelpPage></ASMHelpPage>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ASMHelpPage = defineAsyncComponent(() =>
    import(
        "../../components/Assembly/HelpPage/HelpPage.vue"
        )
);

export default {
    name: "ASM_Help", //The name you are in should not equal the name of the component you are importing.
    components: { ASMHelpPage, AuthLayout },
};
</script>
